import Button from "../Button/Button";
import { Trans } from "react-i18next";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { CheckBox } from "../CheckBox/CheckBox";
import { useState, useEffect } from "react";
import { CheckMarkIcon } from "../icons/CheckMarkIcon";
import { BalanceLightIcon } from "../icons/BalanceLightIcon";
import { NoMakeUpIcon } from "../icons/NoMakeUpIcon";
import { NoGlassesIcon } from "../icons/NoGlassesIcon";
import { useUser } from "../../context/UserContext";
import { useAmplitude } from "../../context/AmplitudeContext";

export const ValidatePage = ({ onFinish }) => {
  const { t, i18n } = useTranslation("homeModule");
  const { uid } = useUser();
  const trackEvent = useAmplitude();
  const [isLicenseMarked, setIsLicenseMarked] = useState(false);
  const [isContinuePressed, setIsContinuePressed] = useState(false);

  useEffect(() => {
    trackEvent("webapp_user_visited_preparation_page", uid);
  }, [uid, trackEvent]);

  return (
    <>
      <div className="validate-header-container">
        <h2 className="validate-title">{t("validate-title")}</h2>
        <p className="validate-sub-title">{t("validate-sub-title")}</p>
      </div>
      <div className="validate-options-container">
        <div className="validate-option">
          <div
            className={`validate-icon-wrapper ${
              isContinuePressed ? "animate-mark" : ""
            }`}
          >
            {isContinuePressed ? (
              <CheckMarkIcon className="validate-icon-small" />
            ) : (
              <BalanceLightIcon className="validate-icon" />
            )}
          </div>
          <p className="validate-option-text">{t("light-text")}</p>
        </div>
        <div className="validate-option">
          <div
            className={`validate-icon-wrapper ${
              isContinuePressed ? "animate-mark" : ""
            }`}
          >
            {isContinuePressed ? (
              <CheckMarkIcon className="validate-icon-small" />
            ) : (
              <NoGlassesIcon className="validate-icon" />
            )}
          </div>
          <p className="validate-option-text">{t("eyewear-text")}</p>
        </div>
        <div className="validate-option">
          <div
            className={`validate-icon-wrapper ${
              isContinuePressed ? "animate-mark" : ""
            }`}
          >
            {isContinuePressed ? (
              <CheckMarkIcon className="validate-icon-small" />
            ) : (
              <NoMakeUpIcon className="validate-icon" />
            )}
          </div>
          <p className="validate-option-text">{t("makeup-text")}</p>
        </div>
      </div>
      {!isContinuePressed && (
        <>
          <div className="license-option">
            <CheckBox
              onClick={() => setIsLicenseMarked((prevValue) => !prevValue)}
            />
            <p className="validate-license-text">
              <Trans
                ns="homeModule"
                i18nKey={"terms-text"}
                components={{
                  click: (
                    <a
                      href={`https://www.iqonic.ai${i18n.language === "de" ? "/de" : ""}/privacy`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="validate-license-text"
                    >
                      {" "}
                    </a>
                  ),
                }}
              />
            </p>
          </div>
          <div className="home-button-wrapper">
            <Button
              text={t("continue")}
              onClick={() => {
                trackEvent("webapp_user_press_continue_preparation_page", uid);
                setIsContinuePressed(true);
                setTimeout(() => onFinish(), 1000);
              }}
              disabled={!isLicenseMarked}
            />
          </div>
        </>
      )}
    </>
  );
};
